import React, { useMemo } from "react";
import FlatPickr from "react-flatpickr";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/themes/material_blue.css";
import "flatpickr/dist/plugins/monthSelect/style.css";

const toDate = (yearMonth) => (yearMonth ? new Date(`${yearMonth}-01T00:00:00`) : null);
const toYearMonth = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;

/**
 * Month-only picker (a year/month grid, one click to jump a whole year) —
 * replaces the native <Input type="month">, whose built-in browser picker
 * only steps one month at a time and makes jumping between years slow.
 * Value/onChange both use "YYYY-MM" strings, same as the native input.
 */
const MonthPicker = ({ value, onChange, disabled, invalid, className = "" }) => {
  // react-flatpickr compares `value` by reference and re-syncs the calendar
  // (resetting its displayed year) whenever it changes — a new Date() on
  // every render made year navigation immediately snap back. Memoized so
  // the reference is stable unless the "YYYY-MM" string itself changes.
  const dateValue = useMemo(() => toDate(value) || undefined, [value]);
  return (
    <FlatPickr
      className={`form-control${invalid ? " is-invalid" : ""}${className ? ` ${className}` : ""}`}
      value={dateValue}
      disabled={disabled}
      options={{
        plugins: [monthSelectPlugin({ shorthand: true, dateFormat: "M Y", altFormat: "F Y" })],
        disableMobile: true,
      }}
      onChange={([date]) => { if (date) onChange(toYearMonth(date)); }}
    />
  );
};

export default MonthPicker;
